<template>
  <div class="event">
      <div class="user-content-inc fluid table-panel deposit-p">
        <slot v-if="home">
            <p>{{ $store.getters['getClientMeta'].name }}</p>
            <h3 class="line-title">Para Yatırın</h3>
            <Loader v-if="loading" :style="!isMobile ? 'margin-top: -15px;' : ''" />
            <List v-if="!loading" :providers="providers" :filter="search" type="deposit" :go="go"></List>
        </slot>
        <slot v-if="!home && !pending_transaction && !user_has_bonus && providers[provider]">
            <slot v-if="!_.isEmpty(providers[provider].form) && !_.isUndefined(providers[provider].setting_id)">
              <component :providerInfo="providers[provider]" :is="'generate'"></component>
            </slot>
            <slot v-else>
              <slot v-if="provider == 'pf_qr' || provider == 'pf_fix' || provider == 'pf_cmt'">
                <component :providerInfo="providers[provider]" :is="'pf'"></component>
              </slot>
              <slot v-else-if="provider == 'favoricepbank' || provider == 'favoriqr'">
                <component :providerInfo="providers[provider]" :is="'favoripay'"></component>
              </slot>
              <slot v-else-if="provider == 'payhera_bank' || provider == 'payhera_papara' || provider == 'payhera_fast'">
                <component :providerInfo="providers[provider]" :is="'payhera'"></component>
              </slot>
              <slot v-else-if="provider == 'fp_cmt' || provider == 'fp_papara'">
                <component :providerInfo="providers[provider]" :is="'fp'"></component>
              </slot>
              <slot v-else-if="provider == 'rocketpay' || provider == 'rocketpay_papara'">
                <component :providerInfo="providers[provider]" :is="'rocketpay'"></component>
              </slot>
              <slot v-else-if="provider == 'anindapay_kart' || provider == 'anindapay_papara' || provider == 'anindapay_mft' || provider == 'anindapay_kripto' || provider == 'anindapay_banka'">
                <component :providerInfo="providers[provider]" :is="'anindapay'"></component>
              </slot>
              <slot v-else-if="provider == 'kral_bank' || provider == 'kral_papara'">
                <component :providerInfo="providers[provider]" :is="'kralpay'"></component>
              </slot>
              <slot v-else-if="provider == 'paygiga' || provider == 'paygiga_qr'">
                <component :providerInfo="providers[provider]" :is="'paygiga'"></component>
              </slot>
              <slot v-else-if="provider == 'instapay_kk' || provider == 'instapay_mft'">
                <component :providerInfo="providers[provider]" :is="'instapay'"></component>
              </slot>
              <slot v-else-if="provider == 'quickpay_card' || provider == 'quickpay_popypara' || provider == 'quickpay_parazula'">
                <component :providerInfo="providers[provider]" :is="'quickpay'"></component>
              </slot>
              <slot v-else-if="provider == 'instant_papara' || provider == 'instant_mft'  || provider == 'instant_bank' || provider == 'instant_qr' || provider == 'instant_kk' || provider == 'instant_btc' || provider == 'instant_cmt'">
                <component :providerInfo="providers[provider]" :is="'instantpay'"></component>
              </slot>
              <slot v-else-if="provider == 'jokerdepays_fast' || provider == 'jokerdepays_bank'">
                <component :provider="provider" :providerInfo="providers[provider]" :is="'jokerdepays'"></component>
              </slot>
              <slot v-else-if="provider == 'jokerdepro_papara' || provider == 'jokerdepro_bank'">
                <component :provider="provider" :providerInfo="providers[provider]" :is="'jokerdepro'"></component>
              </slot>
              <slot v-else-if="provider == 'joker_fast_papara' || provider == 'joker_fast_card' || provider == 'joker_fast_crypto' || provider == 'joker_fast_fast' || provider == 'joker_fast_bank' || provider == 'joker_fast'">
                <component :provider="provider" :providerInfo="providers[provider]" :is="'joker_fast'"></component>
              </slot>
              <slot v-else-if="provider == 'jokerpays_papara' || provider == 'jokerpays_card' || provider == 'jokerpays_crypto' || provider == 'jokerpays_fast' || provider == 'jokerpays_bank'">
                <component :provider="provider" :providerInfo="providers[provider]" :is="'jokerpays'"></component>
              </slot>
              <slot v-else-if="provider == 'red_payment_papara' || provider == 'red_payment_card' || provider == 'red_payment_crypto' || provider == 'red_payment_fast' || provider == 'red_payment_bank'">
                <component :provider="provider" :providerInfo="providers[provider]" :is="'red_payment'"></component>
              </slot>
              <slot v-else-if="provider == 'minipay_card' || provider == 'minipay_bank' || provider == 'minipay_papara' || provider == 'minipay_paycell' || provider == 'minipay_tosla'">
                <component :provider="provider" :providerInfo="providers[provider]" :is="'minipay'"></component>
              </slot>
              <slot v-else-if="provider == 'maksipay_papara' || provider == 'maksipay_bank' || provider == 'maksipay_card' || provider == 'maksipay_pep' || provider == 'maksipay_hayhay' || provider == 'maksipay_payfix' || provider == 'maksipay_mefete' || provider == 'maksipay_crypto' || provider == 'maksipay_paycell'">
                <component :provider="provider" :providerInfo="providers[provider]" :is="'maksipay'"></component>
              </slot>
              <slot v-else>
                <component :providerInfo="providers[provider]" :is="provider"></component>
              </slot>
            </slot>
        </slot>
        <transaction-status v-if="!home && pending_transaction || user_has_bonus" :status="{ 'pending' : pending_transaction, 'bonus_deposit' : user_has_bonus}"/>
      </div>
  </div>
</template>

<script>
  import Top from '../../../../components/User/Pay/Top'
  import List from '../../../../components/User/Pay/List'

  import transactionStatus from '../../../../components/User/Pay/TransactionStatus'
  import generate from './generate'
  import bank from './bank'
  import cepbank from './cepbank'
  import envoy from './envoy'
  import envoy_qr from './envoy_qr'
  import crypto from './crypto'
  import minipay from './minipay'
  import maksipay from './maksipay'
  import pf from './pf'
  import fp from './fp'
  import pf_manuel from './pf_manuel'
  import greycard from './greycard'
  import rocketpay from './rocketpay'
  import favoripay from './favoripay'
  import paytopay_cmt from './paytopay_cmt'
  import kralpay from './kralpay'
  import instantpay from './instantpay'
  import instapay from './instapay'
  import instapay_cep from './instapay_cep'
  import papara_kule from './papara_kule'
  import oto_papara from './oto_papara'
  import credit_kule from './credit_kule'
  import kriptopay from './kriptopay'
  import jeton_wallet from './jeton_wallet'
  import jeton_voucher from './jeton_voucher'
  import paygiga from './paygiga'
  import faturapay from './faturapay'
  import hizlipapara from './hizlipapara'
  import jokerpays from './jokerpays'
  import joker_fast from './joker_fast'
  import jokerdepays from './jokerdepays'
  import jokerdepro from './jokerdepro'
  import red_payment from './red_payment'
  import star_papara from './star_papara'
  import star_crypto from './star_crypto'
  import cashmoney from './cashmoney'
  import cashmoneytwo from './cashmoneytwo'
  import falcon_bank from './falcon_bank'
  import paytron from './paytron'
  import finanspay from './finanspay'
  import payhera from './payhera'
  import jokerbank from './jokerbank'
  import payco from './payco'
  import anindapay from './anindapay'
  import fastpay from './fastpay'
  import papara_iban from './papara_iban'
  import neganpay from './neganpay'
  import quickpay from './quickpay.vue'
  import rcfinance from './rcfinance.vue'

  export default{
    data(){
      return{
        search: '',
        home: true,
        provider: this.$route.params.payment ? this.$route.params.payment : null,
        providers:{},
        loading: false,
      }
    },
    mounted(){
      if(this.$route.params.payment){
        this.home = false;
      }
    },
    computed:{
      pending_transaction(){
        return this.$store.getters['wallet/getPendingTransaction'];
      },
      user_has_bonus(){
        return this.$store.getters['wallet/getUserHasBonus'];
      },
    },
    created(){
      this.fetchData()
    },
    watch: {
        '$route.params.payment': function(slug) {
          if(!this.$route.params.payment){
            this.home = true;
          }else{
            this.home = false;
          }
        }
    },
    methods:{
      fetchData(){
          this.loading = true;
          axios.get('/user/wallet/deposit')
          .then((response)=>{
            this.providers = response.data.list;
            if(!this.providers[this.provider] && !this.home){
              this.$router.push({ name : 'NotFound'})
            }
          })
          .catch(() => {})
          .finally(() => {
            this.loading = false;
          });
      },
      go(name){
        if(this.$route.params.section){
          this.provider = name;
          this.home = false,
          this.$router.push({ params: { section: 'deposit', payment: this.provider } }).catch(error => {
            if (error.name != "NavigationDuplicated") {
              throw error;
            }
          });
        }else{
          this.home = false,
          this.provider = name;
        }
      }
    },
    components:{
      Top,
      List,
      generate,
      bank,
      envoy,
      envoy_qr,
      minipay,
      maksipay,
      crypto,
      instantpay,
      instapay,
      instapay_cep,
      pf_manuel,
      pf,
      fp,
      greycard,
      rocketpay,
      cepbank,
      favoripay,
      paytopay_cmt,
      oto_papara,
      kralpay,
      anindapay,
      papara_kule,
      credit_kule,
      kriptopay,
      jeton_voucher,
      jeton_wallet,
      paygiga,
      jokerbank,
      faturapay,
      star_papara,
      payco,
      hizlipapara,
      rcfinance,
      jokerpays,
      joker_fast,
      jokerdepays,
      jokerdepro,
      red_payment,
      paytron,
      cashmoney,
      cashmoneytwo,
      star_crypto,
      falcon_bank,
      fastpay,
      finanspay,
      payhera,
      neganpay,
      quickpay,
      papara_iban,
      transactionStatus
    }
  }
</script>